/* eslint-disable camelcase */
export default {
	// 商户号查询
	apply_no: '申请单号',
	applicant: '申请人',
	department: '所属部门',
	merchant_subject: '商户号主体',
	group_merchant_name: '供应商门户名称',
	status: '状态',
	merchant_channel: '商户号渠道',
	merchant_type: '商户号类型',
	funds_scene: '资金场景',
	apply_date: '申请日期',
	merchant_number: '商户号',
	operation: '操作',
	draft_flag: '包含草稿',
	please_input_apply_no: '请输入申请单号',
	please_input_merchant_no: '请输入商户号',
	please_search_applicant: '请搜索并选择申请人',
	please_search_dept: '请搜索并选择部门',
	please_search_subject: '请选择或者搜索商户号主体',
	please_input_merchant_name: '请输入供应商门户名称',
	please_select_status: '请选择状态',
	please_select_merchant_channel: '请选择商户号渠道',
	please_select_merchant_type: '请选择商户号类型',
	please_select_funds_scene: '请选择资金场景',
	please_select_biz_feature: '请选择业务特性',
	please_select_merchant_full_name: '请输入供应商门户名称',
	please_select_biz_purpose: '请输入业务用途',
	please_select_biz_product_name: '请输入业务/产品名称',
	please_select_biz_background: '请输入业务背景',
	please_select_funds_flow_desc: '请输入资金流描述',
	please_select_data_flow_desc: '请输入信息流描述',
	please_select_trade_scale: '请输入交易规模',
	please_select_data_check: '请输入交易规模',
	please_select_group_subject: '请选择集团主体',
	please_select_province: '请选择省市',
	please_select_industry: '请选择所属行业',
	please_select_super_admin_type: '请选择超级管理员类型',
	please_input_super_admin_name: '请输入超级管理员姓名',
	please_input_super_admin_phone: '请输入超级管理员联系手机',
	please_select_super_admin_cert_type: '请选择证件类型',
	// validate start
	please_input_finance_auditors: '请填写商户号管理员',
	please_input_biz_auditors: '请填写业务审核人',
	please_input_dept: '请填写业务所属部门',
	please_input_bg: '请填写业务所属BG',
	please_upload_attachments: '请上传业务邮件审核文件',
	please_upload_merchant_name: '请填写商户名称',

	// validate end
	submit: '提交',
	save_draft: '保存草稿',
	back: '返回',
	apply_info: '申请单信息',
	creator: '录入人',
	biz_applyer: '业务申请人',
	biz_checker: '业务审核人',
	super_admin: '商户号管理员',
	biz_dept: '业务所属部门',
	biz_bg: '业务所属BG',
	biz_feature: '业务特性',
	merchant_full_name: '供应商门户名称',
	biz_purpose: '业务用途',
	biz_mail_audit_file: '业务邮件审核文件',
	for_not_fit_biz_tip: '非FiT业务请在“公司业务”项下选择',
	merchant_full_name_tip_1: '此字段用户不可见，仅为内部管理要求命名。',
	merchant_full_name_tip_2: '格式要求：所属BG - 业务线 - 产品名称 - 资金场景',
	merchant_full_name_tip_3: '举例：CSIG - xx业务线 - xx产品 - 收入场景-自营收入/付款场景-营销活动付款',
	biz_product_name: '业务/产品名称',
	biz_background: '业务背景',
	funds_flow_desc: '资金流',
	funds_flow_file: '资金流文件',
	data_flow_desc: '信息流',
	data_flow_file: '信息流文件',
	trade_scale: '交易规模',
	data_check: '对账机制',
	other_statement_file: '其他说明文件',
	biz_info: '业务信息',
	group_subject_info: '集团主体信息',
	group_subject: '集团主体',
	subject_type: '主体类型',
	Operating_info: '经营信息',
	merchant_short_name: '商户简称',
	merchant_short_name_tip_1: '1、在支付完成页向买家展示，需与微信经营类目相关。',
	merchant_short_name_tip_2: '2、简称要求：',
	merchant_short_name_tip_3:
		'不支持单纯以人名来命名，若为个体户经营，可用“个体户+经营者名称”或“经营者名称+业务”命名，如“个体户张三”或“张三餐饮店”；',
	merchant_short_name_tip_4: '②不支持无实际意义的文案，如“XX特约商户”、“800”、“XX客服电话XXX”；',
	service_phone: '客服电话',
	service_phone_tip: '默认电话为腾讯集团公共客服电话，可自行修改',
	sales_scenes: '经营场景',
	sales_scenes_tip_1: '请勾选实际售卖商品/提供服务场景（至少一项），以便为你开通需要的支付权限',
	sales_scenes_tip_2: '填写经营场景指引',
	sales_scenes_tip_3: '建议只勾选目前必须的场景，以便尽快通过入驻审核，其他支付权限你可在入驻后再根据实际需要发起申请',
	sales_scenes_store: '线下场景',
	sales_scenes_mp: '公众号',
	sales_scenes_mini_program: '小程序',
	sales_scenes_app: 'APP',
	sales_scenes_web: '互联网网站',
	sales_scenes_wework: '企业微信',
	sales_scenes_store_name: '线下场所名称',
	sales_scenes_store_province: '线下场景省市',
	sales_scenes_store_address: '线下场所地址',
	sales_scenes_store_indoor_app_view: 'AppID查看指引',
	sales_scenes_store_address_tip_1: '请填写详细的经营场所信息，如有多个场所，选择一个主要场所填写即可',
	sales_scenes_store_entrance_pic: '线下场所门头照片',
	sales_scenes_store_entrance_pic_tip_1:
		'请上传门店照片（要求门店招牌清晰可见）。若为停车场、售卖机等无固定门头照片的经营场所，请提供真实的经营现场照片',
	sales_scenes_store_indoor_pic: '线下场所内部照片',
	sales_scenes_store_indoor_pic_tip_1: '请上传门店内部环境照片。若为停车场、售卖机等无固定门头照片的经营场所，请提供真实的经营现场照片',
	sales_scenes_store_app_id: '线下场所对应的商家AppID',
	sales_scenes_store_indoor_app_tip_1: '1、可填写已认证的公众号、小程序、应用的APPID，其中公众号APPID需是已认证的服务号、政府或媒体类型的订阅号。',
	sales_scenes_store_indoor_app_tip_2: 'AppID查看指引',
	sales_scenes_store_indoor_app_tip_3: '2、完成进件后，系统发起特约商户号与该AppID的绑定（即配置为sub_appid，可在发起支付时传入）',
	sales_scenes_store_indoor_app_tip_4: '（1）若APPID主体与商家主体一致，则直接完成绑定；',
	sales_scenes_store_indoor_app_tip_5: '（2）若APPID主体与商家主体不一致，则商户签约时显示《联合营运承诺函》，并且AppID的管理员需登录',
	sales_scenes_store_indoor_app_tip_6: '公众平台',
	sales_scenes_store_indoor_app_tip_7: '确认绑定意愿；（暂不支持绑定异主体的应用APPID）',
	sales_scenes_mp_app_id: '服务商公众号AppID',
	sales_scenes_mp_app_id_tip_1: '可选择服务商商户号已绑定的APPID，需为已认证的服务号、政府或媒体类型的订阅号。',
	sales_scenes_mp_sub_app_id: '商家公众号AppID',
	sales_scenes_mp_sub_app_id_tip_1: '1、请填写已认证的公众号APPID，需是已认证的服务号、政府或媒体类型的订阅号；',
	sales_scenes_mp_sub_app_id_tip_2: '2、完成进件后，系统发起特约商户号与该AppID的绑定（即配置为sub_appid，可在发起支付时传入）',
	sales_scenes_mp_sub_app_id_tip_3: '（1）若APPID主体与商家主体一致，则直接完成绑定；',
	sales_scenes_mp_sub_app_id_tip_4: '（2）若APPID主体与商家主体不一致，则商户签约时显示《联合营运承诺函》，并且AppID的管理员需登录',
	sales_scenes_mp_sub_app_id_tip_5: '公众平台',
	sales_scenes_mp_sub_app_id_tip_6: '确认绑定意愿；',
	sales_scenes_mp_pic: '公众号页面截图',
	sales_scenes_mp_pic_tip_1: '请提供展示商品/服务的页面截图/设计稿（最多5张），若公众号未建设完善或未上线请务必提供',
	sales_scenes_mini_program_app_id: '服务商小程序APPID',
	sales_scenes_mini_program_app_id_tip_1: '请填写已认证的小程序APPID。',
	sales_scenes_mini_program_sub_app_id: '商家小程序AppID',
	sales_scenes_mini_program_sub_app_id_tip_1: '1、请填写已认证的小程序APPID。',
	sales_scenes_mini_program_sub_app_id_tip_2: '2、完成进件后，系统发起特约商户号与该AppID的绑定（即配置为sub_appid，可在发起支付时传入）。',
	sales_scenes_mini_program_sub_app_id_tip_3: '（1）若APPID主体与商家主体/服务商主体一致，则直接完成绑定。',
	sales_scenes_mini_program_sub_app_id_tip_4: '（2）若APPID主体与商家主体不一致，则商户签约时显示《联合营运承诺函》，并且AppID的管理员需登录',
	sales_scenes_mini_program_sub_app_id_tip_5: '公众平台',
	sales_scenes_mini_program_sub_app_id_tip_6: '确认绑定意愿；',
	sales_scenes_mini_program_pic: '小程序截图',
	sales_scenes_mini_program_pic_tip_1: '请提供展示商品/服务的页面截图/设计稿（最多5张），若小程序未建设完善或未上线请务必提供。',
	sales_scenes_app_app_id: '服务商应用AppID',
	sales_scenes_app_app_id_tip_1: '可填写当前服务商商户号已绑定的应用AppID；',
	sales_scenes_app_sub_app_id: '商家应用AppID',
	sales_scenes_app_sub_app_id_tip_1: '请填写与商家主体一致且已认证的应用APPID；暂不支持绑定异主体的APPID',
	sales_scenes_app_sub_app_id_tip_2:
		'审核通过后，系统将发起特约商家商户号与该AppID的绑定（即配置为sub_appid），服务商随后可在发起支付时选择传入该appid，以完成支付，并获取sub_openid用于数据统计，营销等业务场景。',
	sales_scenes_app_sub_app_id_pic: 'App截图',
	sales_scenes_app_sub_app_id_pic_tip_1: '请提供APP首页截图、尾页截图、应用内截图、支付页截图各1张',
	sales_scenes_app_sub_app_id_pic_tip_2: '查看示例',
	settlement_info: '结算规则',
	label_industry: '所属行业',
	label_industry_tip: '如果没有数据，请先选择集团主体',
	settlement_rule_intro: '所选行业对应的结算规则说明',
	subject_special_category_name: '适用主体特殊身份',
	income_limit_desc: '收款限额',
	credit_limit_desc: '适用信用卡限制说明',
	settlement_funds_flow_desc: '适用资金流说明',
	special_qualification_desc: '特殊资质要求',
	special_qualification_doc: '特殊资质文件',
	special_qualification_doc_tip_1: '资质文件上传要求：',
	special_qualification_doc_tip_2: '1、资质文件应为图片',
	special_qualification_doc_tip_3: '2、资质文件不超过5张图片，且格式要求为：png、jpg、bmp，每张图片应小于2M',
	super_admin_info: '超级管理员信息',
	super_admin_type: '超级管理员类型',
	super_admin_name: '超管姓名',
	super_admin_phone: '联系手机',
	super_admin_email: '邮箱',
	super_admin_cert_type: '证件类型',
	super_admin_cert_number: '证件号码',
	super_admin_open_id: '微信openid',
	super_admin_doc_copy: '证件正面照',
	super_admin_doc_copy_back: '证件反面照',
	super_admin_doc_copy_btn: '上传正面',
	super_admin_doc_copy_back_btn: '上传反面',
	super_admin_authorization_letter: '业务办理授权函',
	super_admin_cert_date: '证件日期',
	sale_scenes_web_domain: '互联网网站域名',
	sale_scenes_web_domain_tip_1: '如为PC端商城、智能终端等场景，可上传官网链接（格式需以http://或https://开头）,如：https://www.wechat.com',
	sale_scenes_web_domain_tip_2: '网站域名需ICP备案，若备案主体与申请主体不同，请上传加盖公章的',
	sale_scenes_web_authorisation: '网站授权函',
	sale_scenes_web_authorisation_tip_1: '若备案主体与申请主体不同，请务必上传加盖公章的网站授权函',
	sale_scenes_web_appid: '互联网网站对应的商家AppID',
	sale_scenes_wework_subcorpid: '商家企业微信CorpID',
	sale_scenes_wework_pics: '企业微信页面截图',
	sales_scenes_web_tip_1: '1、可填写已认证的公众号、小程序、应用的APPID，其中公众号APPID需是已认证的服务号、政府或媒体类型的订阅号。',
	sales_scenes_web_tip_2: 'AppID查看指引',
	sales_scenes_web_tip_3: '2、完成进件后，系统发起特约商户号与该AppID的绑定（即配置为sub_appid，可在发起支付时传入）',
	sales_scenes_web_tip_4: '（1）若APPID主体与商家主体一致，则直接完成绑定；',
	sales_scenes_web_tip_5: '（2）若APPID主体与商家主体不一致，则商户签约时显示《联合营运承诺函》，并且AppID的管理员需登录',
	sales_scenes_web_tip_6: '公众平台',
	sales_scenes_web_tip_7: '确认绑定意愿；（暂不支持绑定异主体的应用APPID）',
	sale_scenes_wework_subcorpid_tip_1:
		'可填写与商家主体一致且已认证的企业微信CorpID；审核通过后，系统将为商家开通企业微信专区的自有交易权限，并完成商家商户号与该CorpID的绑定；',
	sale_scenes_wework_subcorpid_tip_2: 'CorpID查看指引',
	sale_scenes_wework_pics_tip_1: '请提供展示商品/服务的页面截图/设计稿（最多5张）',
	sale_scenes_wework_pics_tip_2: '查看示例',
	cert_query: '证书密钥查询',
	cert_query_result: '证书密钥查询结果',
	change_admin_info: '超级管理员信息',
	payment_base_info: '打款基本信息',
	payment_type: '打款验证类型',
	bill_of_lading_type: '提单类型',
	merchant_apply_no: '商户开立申请单号',
	withdrawal_account: '出款账户',
	withdrawal_card_number: '出款卡号',
	screenshot_of_payment_verification_notification: '打款验证通知截图',
	receiving_account_information: '收款账户信息',
	remittance_instructions: '汇款说明',
	remittance_amount: '汇款金额(元)',
	payee_account_name: '收款户名',
	receipt_card_number: '收款卡号',
	receipt_card_number_first_15_digits: '收款卡号(前15位)',
	receipt_card_number_last_10_digits: '收款卡号(后10位)',
	receipt_card_number_last_10_digits_confirmed: '收款卡号(后10位确认)',
	can_not_be_copied_only_manual_entry: '不能拷贝，只能手动录入',
	please_enter_the_card_number_manually: '请手动录入卡号',
	please_enter_the_merchant_s_opening_application_number: '请输入商户开立申请单号带出出款账户',
	please_enter_the_merchant_s_opening_application_number_admin: '请输入商户号带出出款账户',
	please_enter_the_merchant_s_opening_payee_account_name: '请输入商户开立申请单号带出收款户名',
	please_enter_the_merchant_s_opening_payee_account_name_admin: '请输入商户号带出收款户名',
	please_enter_the_merchant_s_opening_withdrawal_card_number: '请输入商户开立申请单号带出出款卡号',
	please_enter_the_merchant_s_opening_withdrawal_card_number_admin: '请输入商户号带出出款卡号',
	please_enter_the_first_15: '请输入商户开立申请单号带出收款卡号(前15位)',
	please_enter_the_first_15_admin: '请输入商户号带出收款卡号(前15位)',
	card_num_inconsistent: '两次输入的收款卡号(后10位)不一致',
	super_administrator_information_has_not_changed: '超级管理员信息没有变更！',
	submit_application_successfully: '提交申请成功',
	payment_order_number: '付款单号',
	payment_progress: '打款进度',
	payment_verification_result: '打款验证结果',
	legal_person: '法人',
	owner_person: '受益人',
	our_main_body: '我方主体',
	my_merchant_list: '我的商户号列表',
	result_query_code: '进件单号',
	pre_admin: '变更前-管理员',
	next_admin: '变更后-管理员',
	apply_time: '提单时间',
	error_info: '报错信息',
	merchant_info: '商户号信息',
	receive_payment_bank_number: '开户行号',
	receive_payment_bank_account_name: '户名',
	receive_payment_bank_account_number: '银行账户',
	merchant_bank_info: '商户号线下充值收款银行账户信息',
	merchant_bank_info_tip: '注：需要先在微信支付商户号平台开通转账充值功能，且仅支持微信商户号',
	payment_apply_time: '打款提单日期',
	resubmit_new: '重提新申请单',
	supplementary_merchant_number: '补录商户号',
	maintain_receiving_account_information: '维护收款账户信息',
	resubmit_existing_application_form: '重推现有申请单',
	scan_to_check_at_the_payment_institution: '在支付机构扫码核对',
	biz_line: '业务线'
};
